var _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_488394",
    "data-name": "Group 488394",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.047,
    height: 19.313,
    viewBox: "0 0 17.047 19.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_180750",
    "data-name": "Path 180750",
    d: "M74.614,148.636q0-3.337,0-6.674A2.806,2.806,0,0,1,77.562,139c3.155,0,6.309-.006,9.464.011a1.124,1.124,0,0,1,.7.265c1.218,1.126,2.409,2.281,3.618,3.417a.95.95,0,0,1,.32.76q-.014,5.92-.006,11.84a2.814,2.814,0,0,1-3.006,3.019H77.563a2.808,2.808,0,0,1-2.948-2.963Q74.612,151.992,74.614,148.636Zm12.115-8.6c-.138-.013-.223-.028-.308-.028-2.954,0-5.908-.008-8.861,0a1.761,1.761,0,0,0-1.91,1.936c0,4.45.018,8.9-.015,13.35a1.9,1.9,0,0,0,2.018,2.006q5.486-.038,10.973,0a1.893,1.893,0,0,0,2.009-2.014c-.037-3.708-.014-7.416-.014-11.124v-.439c-.749,0-1.45,0-2.151,0A1.588,1.588,0,0,1,86.73,142C86.724,141.361,86.729,140.721,86.729,140.041Zm3.116,2.656-2.107-2c0,.548-.016,1,.005,1.445a.525.525,0,0,0,.552.547C88.771,142.706,89.247,142.7,89.844,142.7Z",
    transform: "translate(-74.614 -138.998)",
    fill: "#8e92a4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180751",
    "data-name": "Path 180751",
    d: "M179.791,273.865c-1.715.792-3.122.518-3.979-.747a2.821,2.821,0,0,1,4-3.864,2.874,2.874,0,0,1,.668,3.9c.588.587,1.19,1.171,1.768,1.779a.789.789,0,0,1,.213.52.493.493,0,0,1-.308.364.759.759,0,0,1-.568-.142c-.529-.481-1.023-1-1.527-1.509C179.956,274.065,179.871,273.956,179.791,273.865Zm.151-2.316a1.8,1.8,0,1,0-1.811,1.788A1.821,1.821,0,0,0,179.941,271.548Z",
    transform: "translate(-167.724 -258.929)",
    fill: "#8e92a4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180752",
    "data-name": "Path 180752",
    d: "M125.408,244.141h-4.375c-.311,0-.591-.059-.662-.417a.469.469,0,0,1,.383-.593,1.679,1.679,0,0,1,.411-.027q4.262,0,8.524,0a2.154,2.154,0,0,1,.3.005c.291.041.5.179.5.5,0,.345-.211.489-.521.524a3.023,3.023,0,0,1-.339,0Z",
    transform: "translate(-116.907 -235.246)",
    fill: "#8e92a4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180753",
    "data-name": "Path 180753",
    d: "M125.448,212.923c1.483,0,2.966,0,4.449,0,.406,0,.62.216.575.565a.463.463,0,0,1-.521.431c-.553,0-1.106,0-1.659,0q-3.657,0-7.314,0c-.3,0-.559-.055-.627-.4s.154-.6.573-.6c1.445,0,2.89,0,4.336,0Z",
    transform: "translate(-116.889 -207.345)",
    fill: "#8e92a4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180754",
    "data-name": "Path 180754",
    d: "M121.722,274.814c-.275,0-.551.005-.826,0a.5.5,0,1,1,.014-.992q.826-.015,1.652,0a.512.512,0,0,1,.54.5.53.53,0,0,1-.554.492h-.826Z",
    transform: "translate(-116.938 -263.642)",
    fill: "#8e92a4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseIcon);
export default __webpack_public_path__ + "static/media/case_icon.0acb4d31bb7a5c2cf65372baa46b1370.svg";
export { ForwardRef as ReactComponent };